import moment from 'moment';

const EMPTY_SLOT = { empty: true };
const CAROUSEL_SIZE = 5;

export const sortSessionsByDateDesc = (sessions = []) =>
  [...sessions].sort((a, b) => moment(b.date || b.last_assigned).diff(moment(a.date || a.last_assigned)));

export const padCarouselSessions = (sessions = [], size = CAROUSEL_SIZE) =>
  Array.from({ length: size }, (_, index) => sessions[index] || EMPTY_SLOT);
